export default __webpack_public_path__ + "./fonts/opera.3a3309d5113e7c8a7ffbb7070f50684d.svg";